module.exports = __webpack_public_path__ + "img/tip-left.7af1e580.png";